export default (props) => (
  /**
   * Ícone escala da cores colorida.
   * Utilizada no dropdown "Escala de cores"
   * na edição de simbologia.
   */
  <svg
    width="176"
    height="22"
    viewBox="0 0 176 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.447266 3.17969C0.447266 1.52284 1.79041 0.179688 3.44727 0.179688H12.1253V21.5912H3.44726C1.79041 21.5912 0.447266 20.2481 0.447266 18.5912V3.17969Z"
      fill="#4C38BA"
    />
    <path
      d="M175.618 18.5937C175.618 20.2506 174.275 21.5937 172.618 21.5937L163.94 21.5937L163.94 0.182237L172.618 0.182237C174.275 0.182238 175.618 1.52538 175.618 3.18224L175.618 18.5937Z"
      fill="#417DB3"
    />
    <path
      d="M12.1255 0.179688H23.8035V21.5912H12.1255V0.179688Z"
      fill="#B13E54"
    />
    <path
      d="M23.8032 0.179688H35.4812V21.5912H23.8032V0.179688Z"
      fill="#1F89BA"
    />
    <path
      d="M35.4814 0.179688H47.1595V21.5912H35.4814V0.179688Z"
      fill="#58BD5C"
    />
    <path
      d="M47.1592 0.179688H58.8372V21.5912H47.1592V0.179688Z"
      fill="#D254BD"
    />
    <path
      d="M58.8374 0.179688H70.5154V21.5912H58.8374V0.179688Z"
      fill="#AB571C"
    />
    <path
      d="M70.5156 0.179688H82.1937V21.5912H70.5156V0.179688Z"
      fill="#3D6CB6"
    />
    <path
      d="M82.1934 0.179688H93.8714V21.5912H82.1934V0.179688Z"
      fill="#549338"
    />
    <path
      d="M93.8716 0.179688H105.55V21.5912H93.8716V0.179688Z"
      fill="#9C4862"
    />
    <path
      d="M105.549 0.179688H117.227V21.5912H105.549V0.179688Z"
      fill="#C2902B"
    />
    <path
      d="M117.228 0.179688H128.906V21.5912H117.228V0.179688Z"
      fill="#894E9B"
    />
    <path
      d="M128.906 0.179688H140.584V21.5912H128.906V0.179688Z"
      fill="#30A087"
    />
    <path
      d="M140.583 0.179688H152.262V21.5912H140.583V0.179688Z"
      fill="#C75026"
    />
    <path
      d="M152.262 0.179688H163.94V21.5912H152.262V0.179688Z"
      fill="#A3AA34"
    />
  </svg>
);
